import { ReactElement } from "react";
import { TitleBarButton } from "./TitleBarButton/TitleBarButton";
import { localize } from "client_legacy/ndaw/culture";
import {
	MainMenuItem,
	useMainMenuItemActivationHandlers
} from "../mainMenuStore";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export type PlusMenuButtonProps = {
	headerStyle: WorkspaceHeaderStyle;
};

export const PlusMenuButton = (props: PlusMenuButtonProps): ReactElement => {
	const {
		headerStyle
	} = props;

	const {
		activate
	} = useMainMenuItemActivationHandlers(MainMenuItem.CreateItem);

	return (
		<TitleBarButton
			headerStyle={headerStyle}
			icon="plus"
			text={localize("_Create")}
			onClick={() => activate()}
			trackingId="create-button"
		/>
	);
};
PlusMenuButton.displayName = "PlusMenuButton";